<template lang="pug">
  v-card.rounded-lg.px-4(min-height="150" width="100%")
    v-card-title.justify-center.main-title-primary {{title}}
    //- stats
    v-row.mx-3(v-if="!loadingData")
      v-col.px-1.mx-auto(v-if="movements && movements != ''" cols="6" xs="6" sm="6" md="4")
        mobileCard.mx-auto(color='#fb8c00', icon='mdi-finance', valueIcon='#' title="Movimientos", :value='movements')
      v-col.px-1.mx-auto(v-if="total != ''" cols="6" xs="6" sm="6" md="4")
        mobileCard.mx-auto(color='#00bcd4', icon='mdi-cash', valueIcon='$' title="Total", :value='total')
      v-col.px-1.mx-auto(v-if="utility != ''" cols="12" xs="12" sm="6" md="4")
        mobileCard.mx-auto(color='#008e95', icon='mdi-cash', valueIcon='$' title="Utilidad", :value='utility')
    //- Skeleton
    v-row.mx-auto(v-else)
      v-col.px-1(cols="6" xs="6" sm="6" md="3" v-for="i of skeletonQty" )
        v-skeleton-loader.mx-auto.my-4.rounded-lg(tile type='card' transition='scale-transition' height="50" width='100')
</template>

<script>
  export default {
    components: {
      mobileCard: () => import('@/views/custom/transactions/MobileCard.vue'),
    },
    props: {
      title: {
        type: String,
        default: 'Movimientos generales',
      },
      movements: {
        type: String,
        default: '0',
      },
      total: {
        type: String,
        default: '0',
      },
      utility: {
        type: String,
        default: '0',
      },
    },
    data: () => ({
      loadingData: false,
    }),
    mounted () {
    },
    /* computed: {
      skeletonQty () {
        return this.showExpenses ? 4 : 3
      },
    }, */
    methods: {
      fetch () {
        const vm = this
        if (vm.searching) return
        vm.getSales(vm.from, vm.to)
        vm.getPurchases(vm.from, vm.to)
        vm.getExpenses(vm.from, vm.to)
      },
      getSales (from, to) {
        const vm = this
        vm.loadingData = true
        vm.searching = true
        vm.$store.dispatch('transactions/loadLogTotals', { type: 'sales', from: from, to: to, shop: vm.shop }).then(function (res) {
          vm.loadingData = false
          vm.sales = res.total || 0
          vm.utility = res.revenue || 0
          vm.searching = false
        }).catch((error) => {
          console.log(error)
          vm.loadingData = false
          vm.searching = false
        })
      },
      getExpenses (from, to) {
        const vm = this
        vm.$store.dispatch('transactions/loadLogTotals', { type: 'expenses', from: from, to: to, shop: vm.shop }).then(function (res) {
          vm.expenses = res.total || 0
        })
      },
      getPurchases (from, to) {
        const vm = this
        vm.$store.dispatch('transactions/loadLogTotals', { type: 'purchases', from: from, to: to, shop: vm.shop }).then(function (res) {
          vm.purchases = res.total || 0
        })
      },
    },
  }
</script>
